import React from 'react';

/**
 * Spinner - centered indeterminate loader.
 *
 * Props:
 *   label - optional caption shown beneath the spinner
 *   size  - sm | md (default) | lg
 */

const SIZES = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-[3px]',
};

export default function Spinner({ label, size = 'md', className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`${SIZES[size] || SIZES.md} border-brand-500 border-t-transparent rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {label && <p className="text-sm text-slate-500 font-medium">{label}</p>}
    </div>
  );
}
